export const CONSTANTS = {
    HTTP: {
        'SUCCESS': 200,
		'NO_CONTENT': 204,
		'NOT_FOUND': 404
    },
    DEFAULTS: {
        VIEW: 'Status', //default view
        VIEWSTAFF: 'Staff',
        VIEWAREA: 'BYAREA',
        VIEWSTATE: 'BYSTATE',
        VIEWMANAGER: 'Manager',
        VIEWSUPERVISOR: 'Supervisor',
        VIEWSPID: 'SPID',
        VIEWSEG: 'Segment',
        VIEWASSIGN: 'Assignments',
        STATUS: 'SUSPECT', //default status
        ALLSTAFF: 'ALLSTAFF',
        AREA: 'ALL', //default area
        STATE: 'ALL', //default state
        SPID: 'ALL', //default SPID
        SEGMENT: 'ALL',
        DATEFORMAT: 'MM/dd/yyyy',
        REGION: 'R',
        CTHRESHOLD: '500'
    }
};
